import React from "react";

const CloseIcon = ({ width = 24, height = 24, color = "black" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.4246 12.975L7.52461 17.875C7.34128 18.0583 7.10794 18.15 6.82461 18.15C6.54128 18.15 6.30794 18.0583 6.12461 17.875C5.94128 17.6917 5.84961 17.4583 5.84961 17.175C5.84961 16.8917 5.94128 16.6583 6.12461 16.475L11.0246 11.575L6.12461 6.675C5.94128 6.49167 5.84961 6.25833 5.84961 5.975C5.84961 5.69167 5.94128 5.45833 6.12461 5.275C6.30794 5.09167 6.54128 5 6.82461 5C7.10794 5 7.34128 5.09167 7.52461 5.275L12.4246 10.175L17.3246 5.275C17.5079 5.09167 17.7413 5 18.0246 5C18.3079 5 18.5413 5.09167 18.7246 5.275C18.9079 5.45833 18.9996 5.69167 18.9996 5.975C18.9996 6.25833 18.9079 6.49167 18.7246 6.675L13.8246 11.575L18.7246 16.475C18.9079 16.6583 18.9996 16.8917 18.9996 17.175C18.9996 17.4583 18.9079 17.6917 18.7246 17.875C18.5413 18.0583 18.3079 18.15 18.0246 18.15C17.7413 18.15 17.5079 18.0583 17.3246 17.875L12.4246 12.975Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
